// extracted by mini-css-extract-plugin
var _1 = "PostModalViewResizeButton-module__animateUploadProgressBarWidth--AYV6e";
var _2 = "PostModalViewResizeButton-module__animatedBackground--idIEs";
var _3 = "PostModalViewResizeButton-module__resizeHandler--Kr726";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "resizeHandler" }
